export const externalWhitelistKeys = {};

export const externalFalsyChecksOk = (key, contextValue, reduxValue) => {
  const nullIsOkForUndefined = {
    shipmentEmailNotificationTemplateId: true,
    deliveryEmailNotificationTemplateId: true,
  };
  if (nullIsOkForUndefined[key] && contextValue === null && reduxValue === undefined) {
    return true;
  }
  return false;
};
